<template>
  <div>
    <div class="first">
      <div class="nav-top clearfix">
        <div class="nav-list fl">
          <!-- <div>全部分组</div>
          <div @click="getFirst">全部分组</div> >-->
          <div class="nav-active" @click="returnFirst">{{ treeListGroup.ClassTerminalGroupName }}</div>
          <!-- <div @click="getFirst">全部分组</div> >
                    <div @click="getSecond">{{ second.ClassTerminalGroupName }}</div> >
                    <div @click="getThird">{{ third.ClassTerminalGroupName }}</div> >
          <div class="nav-active">{{ treeListGroup.ClassTerminalGroupName }}</div>-->
        </div>
        <van-button
          class="all fr"
          size="small"
          round
          @click.native="checkChange()">{{treeListGroup.isCheck ? '取消全选':'全选'}}</van-button>
      </div>
      <div class="check-group-list-box" style="margin-top:10px;padding-bottom:100px;" v-if="treeListGroup.children.length>0">
        <div class="check-group-list">
          <div class="check-group-list-div"
              v-for="item in treeListGroup.children"
              :key="item.ClassTerminalGroupID">
            <div class="check-group-list-row"
                v-bind:val="item.ClassTerminalGroupID"
                round
                @click="checkChange(item)">
              <van-checkbox class="check-group-list-check" v-model="item.isCheck" shape="square">
                <span class="check-group-list-name">{{item.ClassTerminalGroupName}}（{{ item.num }}个）</span>
              </van-checkbox>
              <!-- <span class="check-group-list-check">
                                <i class="fa" v-bind:class="item.isCheck ? 'fa-check-circle' : 'fa-circle-thin'"></i>
                            </span>
              <span class="check-group-list-name">{{item.ClassTerminalGroupName}}（{{ item.num }}个）</span>-->
            </div>
            <van-icon class="fa fa-angle-right fr check-group-list-icon"
                      name="arrow"
                      @click="inTree(item)" />
            <!-- <i class="fa fa-angle-right fr check-group-list-icon" @click="inTree(item)"></i> -->
          </div>
        </div>
      </div>
      <!-- 班牌 -->
      <div class="check-group-list-box" style="margin-top:10px;padding-bottom:100px;">
        <div class="check-group-list">
          <!-- TreminalS treminalS -->
          <div class="check-group-list-div"
                v-for="item in treeListGroup.TreminalS"
                :key="item.ClassTerminalGroupID">
            <div class="check-group-list-row"
                v-bind:val="item.ClassTerminalGroupID"
                round
                @click="checkChange(item)"
                style="width:100%;">
              <van-checkbox class="check-group-list-check" v-model="item.isCheck" shape="square">
                <img class="check-ban-icon" src="@/assets/infoPublic/images/ban@2x.png" />
                <span class="check-group-list-name">{{item.ClassTerminalName}}</span>
              </van-checkbox>
              <!-- <span class="check-group-list-check">
                                <i class="fa" v-bind:class="item.isCheck ? 'fa-check-circle' : 'fa-circle-thin'"></i>
                            </span>
                            <img class="check-ban-icon" src="@/assets/infoPublic/images/ban@2x.png" />
              <span class="check-group-list-name">{{item.ClassTerminalName}}</span>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "First",
    data() {
      return {
        treeListGroup: [],
        contList: [],
        isScreenMode: true,
        ScreenModeNumber: null,
        noticeData: "",
        type: "",
        ClassTerminalList:[]
      }
    },
    computed: {},
    created() {
      this.treeListGroup = this.$store.state.infoPublic.treeListGroup;
      this.noticeData = this.$store.state.infoPublic.noticeData;
      this.type = this.$store.state.infoPublic.typePic;
      this.contList = this.$store.state.infoPublic.contList;
        // 数组id
      this.ClassTerminalList = this.$store.state.infoPublic.checkedArr;
      console.log(this.ClassTerminalList)

      if (this.$parent.noticeData === undefined) {
        this.isScreenMode = false;
      }
      // console.log(this.treeListGroup.children,'wym')
    },
    mounted() {
      this.ScreenMode();
    },
    methods: {
      // 判断横竖版班牌
      ScreenMode() {
        let noticeData
        if (this.type === 7) {
          noticeData = this.noticeData.ScreenMode;
        } else {
          noticeData = this.noticeData;
        }
        if (noticeData !== undefined) {
          this.ScreenModeNumber = this.noticeData.ScreenMode;
          if (this.ScreenModeNumber !== null) {
            this.isScreenMode = true;
          } else {
            this.isScreenMode = false;
          }
        } else {
          this.ScreenModeNumber = -1;
          if (this.ScreenModeNumber !== null) {
            this.isScreenMode = false;
          } else {
            this.isScreenMode = true;
          }
        }
      },

      // 选择
      checkChange(value) {
        if (value === undefined) {
           value = this.treeListGroup;
        }
        console.log(value);
        // 选中组下所有id班牌
        this.$parent.contList = [];
        this.$parent.numList(value);
        this.contList = this.$parent.contList;

        value.isCheck = !value.isCheck;
        this.$parent.alreadyElement(value);

        // 控制父级全选
        this.$parent.alreadyParent(this.treeListGroup);
        if (value.isCheck) {
          // 已选
          this.$parent.checkedFunc(this.contList);
        } else {
          // 取消
          this.$parent.removeElement(this.contList);
        }
      },
      // 返回首级菜单
      returnFirst() {
        this.treeListGroup = this.$parent.treeListGroup;
      },

      // 进入二级菜单
      inTree(val) {
        console.log(val);
        this.treeListGroup = val;
      },
      // 首页
      getFirst() {
        //  this.treeListGroup = this.$parent.treeListGroup;
      },

      // 第二页
      getSecond() {},

      // 第三页
      getThird() {}
    }
  };
</script>
<style lang="less" scoped>
  /* 选择班牌第一级 */
  .first {
    margin-bottom: 50px;
  }
  .nav-top {
    background: #fff;
    height: 80px;
    padding: 0 2%;
    line-height: 80px;
    overflow: hidden;
  }
  .nav-top > .nav-list {
    white-space: nowrap;
    width: 40%;
    overflow: auto;
  }
  .nav-top > .nav-list > div {
    font-size: 28px;
    display: inline-block;
    margin: 0 10px;
  }
  .nav-top > .all {
    margin-top: 10px;
  }
  .nav-active {
    color: #4196ff;
  }
  .check-group-list-box > .check-group-list {
    background: #fff;
  }
  .check-group-list-box > .check-group-list > .check-group-list-div {
    white-space: nowrap;
  }
  .check-group-list-row {
    display: inline-block;
    height: 100px;
    line-height: 100px;
    border-top: 2px solid #f2f2f2;
    padding: 0;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }
  // .check-group-list-row > .check-group-list-check {
  // }

  .check-group-list-row > .van-checkbox {
    margin: 30px 20px 30px 30px;
  }

  .check-group-list-row > .check-group-list-check > i {
    font-size: 40px;
    color: #4196ff;
    display: inline-block;
    vertical-align: middle;
    margin: 30px 20px 30px 30px;
  }

  .check-group-list-row-dis {
    display: inline-block;
    height: 100px;
    line-height: 100px;
    border-top: 2px solid #f2f2f2;
    padding: 0;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  // .check-group-list-row-dis > .check-group-list-check {
  // }

  .check-group-list-row-dis > .check-group-list-check > i {
    font-size: 40px;
    color: #cacaca;
    display: inline-block;
    vertical-align: middle;
    margin: 30px 20px 30px 30px;
  }
  .check-group-list-row-dis > .check-group-list-name {
    color: #999;
  }

  .check-ban-icon {
    width: 38px;
  }

  // .check-group-list-name {
  // }
  .check-group-list-icon {
    width: 20%;
    height: 100px;
    font-size: 48px;
    color: #999;
    line-height: 100px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
  }
</style>
